import * as classNames from 'classnames'
import * as React from 'react'
import * as moment from 'moment'
import { TripStatuses } from '../../constants/trip-statuses'
import history from '../../history'
import { IRecentTripObj, ITripStatus } from '../../types'
import Copy from '../icons/ui/Copy'
import ToolTip from '../ui/ToolTip'
import Van from '../icons/trips/Van'
import ToIcon from '../icons/trips/ToIcon'
import Handicafe from '../icons/trips/Handicafe'
import StatusTag from '../ui/StatusTag'
import ImageView from '../ui/ImageView'
import { completedTripStatuses, tripsStatuses } from 'src/state/constants'

interface IDashboardItemProps {
  trip: IRecentTripObj
  cloneTrip?: (e: any) => void
  waitingTime?: number
  resendRequest?: (tripId: string) => void
  getManyStatusesById?: (tripId: string) => Promise<ITripStatus[]>
}

class DashboardItem extends React.Component<IDashboardItemProps> {
  constructor(props: IDashboardItemProps) {
    super(props)
  }

  public render() {
    const { trip, cloneTrip } = this.props
    const rider = trip.rider
    const operator = trip.operator
    const goToTrip = () => {
      history.push(`/station-user-trips/${this.props.trip.id}`)
    }

    const addressParts = ((trip && trip.pickupLocation && trip.pickupLocation.fullAddress) || '').split(',')
    const shortAddress = addressParts[0] + ', ' + addressParts[1]
    let statusTime = trip.lastStatusAt
    if (trip && trip.scheduledPickupTime) {
      statusTime = trip.scheduledPickupTime
    }

    const dropoffTime = trip.scheduledDropoffTime ? moment(trip.scheduledDropoffTime).format('M/D/YYYY hh:mmA') : ''
    const tripCompleted = completedTripStatuses.includes(trip.lastStatus)

    const pickedUpStatus = trip.status.find(s => s.status === tripsStatuses.pickedUp)
    const estimatedDropOff =
      pickedUpStatus && !tripCompleted
        ? new Date(+new Date(pickedUpStatus.createdAt) + trip.estimatedDuration * 1000)
        : null

    const estimatedDropOffTime = estimatedDropOff ? moment(estimatedDropOff).format('hh:mmA') : ''
    const dropOffDiff =
      trip.scheduledDropoffTime && estimatedDropOff ? +estimatedDropOff - +new Date(trip.scheduledDropoffTime) : 0
    let estimatedLevel = 'green'
    if (dropOffDiff < 0) {
      estimatedLevel = 'green'
    } else if (dropOffDiff > 0 && dropOffDiff < 10 * 60 * 1000) {
      estimatedLevel = 'blue'
    } else if (dropOffDiff < 20 * 60 * 1000) {
      estimatedLevel = 'light-red'
    } else if (dropOffDiff < 30 * 60 * 1000) {
      estimatedLevel = 'red'
    } else {
      estimatedLevel = 'black'
    }

    if (!rider) {
      return null
    }

    return (
      <div className='flex flex-column px1 route-items'>
        <div className='trips-user'>
          <div className=' flex cursor--pointer mt1 col-12' onClick={goToTrip}>
            {/* {trip.tripType === 'app' && <img className='mr1 mb2 w50 image' src='/images/trip-request/app-request.svg' />}
          {trip.tripType === 'import' && (
            <img className='mr1 mb2 w50 image' src='/images/trip-request/import-request.svg' />
          )}
          {trip.tripType === 'phone' && (
            <img className='mr1 mb2 w50 image' src='/images/trip-request/phone-request.svg' />
          )} */}
            {/* Trips Main  - Set Avatar*/}
            <ImageView
              entityId={rider ? rider.riderId : undefined}
              name={rider.firstName + ' ' + rider.lastName}
              isRounded={true}
              width='50px'
              height='50px'
            />
            {/* Trips Main  - Set Avatar*/}
            <div className='col ml2'>
              <div className='flex col-12 items-center'>
                {rider && (
                  <div className='h5 flex w-100'>
                    {`${rider.firstName} ${rider.lastName}`}{' '}
                    <span className='pl1'>
                      <Handicafe />
                    </span>
                  </div>
                )}
              </div>

              <p className='flex'>
                {' '}
                {trip && (
                  <div className='h6 font-grey2 '>
                    <ToIcon />
                    {shortAddress}{' '}
                  </div>
                )}
              </p>

              {/* <div className='h6 font-grey2'>{this.props.trip.product.name}</div> */}
              <div className='flex items-center mt1'>
                <StatusTag status={trip.lastStatus || 'NO STATUS'} />
                {statusTime ? (
                  <ToolTip message={moment(statusTime).format('MMM Do, h:mm a')}>
                    <div className='ml2 h6 bold font-gray5'>{moment(statusTime).fromNow()}</div>
                  </ToolTip>
                ) : null}
              </div>
            </div>
            {estimatedDropOffTime && (
              <div className='col col-auto ml-auto mt1'>
                <div className={'timin-btn mt1 font-white bg-' + estimatedLevel}>{estimatedDropOffTime}</div>
              </div>
            )}
          </div>
          {/* <div title='Request Again' className='ml1 cursor--pointer'>
            <Copy onClick={cloneTrip} />
          </div> */}
        </div>
        <div className='flex next-trip mt1 ml2'>
          <Van />
          <div className='ml2 h5'>{operator ? `${operator.firstName} ${operator.lastName}` : null}</div>
          <div className='ml-auto h5'>{dropoffTime}</div>
        </div>
      </div>
    )
  }
}

export default DashboardItem



// WEBPACK FOOTER //
// ./src/components/station-user-trips/DashboardItem.tsx